$(document).ready(function () {
  if ($("body").hasClass("template-product")) {
    $(".product-technology-sc").each(function () {
      if ($.trim($(this).html()) === "") {
        $(this).hide();
      }
    });
  }
});

$(document).ready(function () {
  // Loop through each .cart-item row
  $(".cart-item").each(function () {
    console.log("Checking .cart-item:", $(this)); // Log the current cart item

    // Check if there is an empty <dl> inside .cart-item__details
    const emptyDLExists =
      $(this)
        .find(".cart-item__details dl")
        .filter(function () {
          console.log("Checking <dl> content:", $(this).html()); // Log the content of each <dl>
          return $.trim($(this).html()) === ""; // Check if <dl> is empty or contains only whitespace
        }).length > 0;

    console.log("Empty <dl> exists:", emptyDLExists); // Log if empty <dl> is found

    if (emptyDLExists) {
      // Select the quantity-popover tag within the current cart item
      var quantityPopover = $(this).find("quantity-popover");
      console.log("Found quantity-popover:", quantityPopover); // Log the found quantity-popover

      if (quantityPopover.length > 0) {
        // Apply the margin-top of 45px to quantity-popover
        quantityPopover.css("margin-top", "-55px");
        console.log("Applied margin-top: 45px"); // Log when margin is applied
      } else {
        console.log("No quantity-popover found"); // Log if no quantity-popover is found
      }
    }
  });
});

if (window.innerWidth < 1025) {
  var swiper = new Swiper(".our-points-slider-block", {
    slidesPerView: 2.2,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
      },
      0: {
        slidesPerView: 1.2,
      },
    },
  });
  var swiper = new Swiper(".meet-the-team-slider-block", {
    slidesPerView: 3.2,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 3.2,
      },
      480: {
        slidesPerView: 2.2,
      },
      0: {
        slidesPerView: 1.2,
      },
    },
  });
}

var swipertwo = new Swiper(".shopnow-carousel-inner-block", {
  slidesPerView: 3.2,
  spaceBetween: 12,
  loop: true,
  resistance: true,
  resistanceRatio: 0,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 3.2,
    },
    580: {
      slidesPerView: 2.2,
    },
    0: {
      slidesPerView: 1.2,
    },
  },
});

var swiper = new Swiper(".reviews-carousel-block", {
  slidesPerView: 2.1,
  spaceBetween: 12,
  loop: true,
  freeMode: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2.1,
    },
    0: {
      slidesPerView: 1.2,
    },
  },
});

var swiper = new Swiper(".blog-carousel-block", {
  slidesPerView: 2,
  spaceBetween: 12,
  loop: true,
  navigation: {
    nextEl: ".article-carousel-next",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1.2,
    },
  },
});

if (window.innerWidth > 767) {
  var swiper = new Swiper(".our-products-catalogue-block", {
    slidesPerView: 5,
    spaceBetween: 12,
    loop: true,
    breakpoints: {
      1120: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 4,
      },
      0: {
        slidesPerView: 3.2,
      },
    },
  });
  var swiper = new Swiper(".our-products-catalogue-block-two", {
    slidesPerView: 5.2,
    spaceBetween: 12,
    loop: true,
    breakpoints: {
      1120: {
        slidesPerView: 5.2,
      },
      992: {
        slidesPerView: 4.2,
      },
      0: {
        slidesPerView: 3.2,
      },
    },
  });
}
$(document).ready(function () {
  // Select all spans with the class .btn-primary-inner-block
  $(".btn-primary-inner-block").each(function () {
    // Get the computed width of the span
    var btnspanWidth = $(this).width();

    // Set the width back to the span's style
    $(this).css("width", btnspanWidth);
  });

  // Hide all popups initially
  $(".team-member-popup").hide();

  // Function to show popup
  function showPopup(memberId) {
    var popupId = "#popup-" + memberId;

    // Hide all popups
    $(".team-member-popup").hide();

    // Show the corresponding popup with fade-in effect
    $(popupId).fadeIn();
  }

  // Handle click on team member name
  $("h3[data-member-id]").click(function () {
    var memberId = $(this).data("member-id");
    showPopup(memberId);
  });

  // Handle click on team member image
  $(".meet-the-team-member-image").click(function () {
    var memberId = $(this).data("member-id");
    showPopup(memberId);
  });

  // Handle click on close button inside popup
  $(".team-member-popup-close-button").click(function () {
    $(this).closest(".team-member-popup").fadeOut();
  });

  // Check if the body has a specific class
  if ($("body").hasClass("template-page-about")) {
    // Add a class to the html tag
    $("html").addClass("about-templateshopify");
  }

  if ($("body").hasClass("template-article")) {
    // Add a class to the html tag
    $("html").addClass("article-templateshopify");
  }

  // Get padding-left and margin-left of .primary-container
  var sc_leftPaddingLeft = parseInt($(".page-width").css("padding-left"));
  var sc_leftMarginLeft = parseInt($(".page-width").css("margin-left"));

  // Sum the padding-left and margin-left
  var sc_leftTotalLeft = sc_leftPaddingLeft + sc_leftMarginLeft;

  // Apply the sum as padding-left to .special-left-container
  $(".spleft-pagewidth").css("padding-left", sc_leftTotalLeft);

  // Function to update the minimum height
  function updateMinHeight() {
    if ($(window).width() > 767) {
      // Get the height of the active slide
      var activeSlideHeight = $(
        ".blog-carousel-slide.swiper-slide-active"
      ).outerHeight();

      // Apply this height as the minimum height for all slides
      $(".blog-carousel-slide.swiper-slide").css(
        "min-height",
        activeSlideHeight + "px"
      );
    } else {
      // Remove the min-height if window width is 767px or less
      $(".blog-carousel-slide.swiper-slide").css("min-height", "");
    }
  }

  // Call the function on document ready
  updateMinHeight();

  // Call the function on window resize
  $(window).resize(function () {
    updateMinHeight();
  });

  function moveShareBlock() {
    if ($(window).width() < 1025) {
      $(".blogdt-share-block").appendTo(".blogdetail-rht-block");
    } else {
      // Optionally, move it back to the original position when the width is 768px or above
      $(".blogdt-share-block").appendTo(".blogdetail-lft-block");
    }
  }

  // Initial check
  moveShareBlock();

  // Check on window resize
  $(window).resize(function () {
    moveShareBlock();
  });

  function moveBackButtonk() {
    if ($(window).width() < 1025) {
      $(".blogdt-backpage-button").appendTo(".blogdetail-ftimg-block");
    } else {
      // Optionally, move it back to the original position when the width is 768px or above
      $(".blogdt-backpage-button").appendTo(".blogdetail-lft-block");
    }
  }

  // Initial check
  moveBackButtonk();

  // Check on window resize
  $(window).resize(function () {
    moveBackButtonk();
  });
});

$(document).ready(function () {
  let index = 0;
  const accordions = $(".accordion-item");
  const images = $(".image-section .product-features-accordian-content");
  const cycleTime = 5000;
  const fadeTime = 800; // Adjust fade time as needed
  const progressInterval = 50; // Update progress bar every 50ms
  let interval, progressIntervalId;

  // Hide all accordion contents except the first one
  accordions.find(".accordion-content").hide();
  accordions.first().find(".accordion-content").show();
  // accordions.find('.progress-bar').width(0);

  function showAccordion(index) {
    // Slide up all accordion contents except the one being toggled
    accordions
      .not(accordions[index])
      .find(".accordion-content")
      .slideUp()
      .parent()
      .removeClass("active");

    // Toggle the selected accordion content
    const $currentAccordion = $(accordions[index]);
    if ($currentAccordion.hasClass("active")) {
      $currentAccordion
        .removeClass("active")
        .find(".accordion-content")
        .slideUp();
    } else {
      $currentAccordion
        .addClass("active")
        .find(".accordion-content")
        .slideDown();
    }
    // Fade out all images
    images.removeClass("active").fadeOut(fadeTime);
    // Fade in the selected image
    $(images[index]).fadeIn(fadeTime).addClass("active");

    // Reset progress bar
    // accordions.find('.progress-bar').width(0);
    // updateProgressBar(index);
  }

  // function updateProgressBar(index) {
  //     clearInterval(progressIntervalId);
  //     let width = 0;
  //     progressIntervalId = setInterval(function() {
  //         width += (progressInterval / cycleTime) * 100;
  //         if (width >= 100) {
  //             clearInterval(progressIntervalId);
  //         }
  //         $(accordions[index]).find('.progress-bar').css('width', width + '%');
  //     }, progressInterval);
  // }

  // function autoCycle() {
  //     index = (index + 1) % accordions.length;
  //     showAccordion(index);
  // }

  // function startCycle() {
  //     clearInterval(interval);
  //     interval = setInterval(autoCycle, cycleTime);
  // }

  accordions.find(".accordion-header").click(function () {
    index = $(this).parent().index();
    showAccordion(index);
    // startCycle();
  });

  showAccordion(index);
  // startCycle();
});
$(document).ready(function () {
  // Each FAQ On click Slide Up/Down Code
  $(".faq-c-qa-e-b-block").hide();

  // Open the body of the first FAQ block and add 'active' class to its parent
  $(".faq-c-qa-e-block").first().find(".faq-c-qa-e-b-block").show();
  $(".faq-c-qa-e-block").first().addClass("active");

  $(".faq-c-qa-e-block").click(function () {
    const $parent = $(this).closest(".faq-c-qa-e-block");
    const $answer = $parent.find(".faq-c-qa-e-b-block");

    // Check if the clicked question is already active
    if ($parent.hasClass("active")) {
      $answer.slideUp(() => {
        $parent.removeClass("active");
      });
    } else {
      // Close any currently open answers and toggle their icons
      // $('.faq-c-qa-e-block .faq-c-qa-e-b-block').slideUp();
      // $('.faq-c-qa-e-block.active').removeClass('active');

      // Open the clicked one
      $answer.slideDown();
      $parent.addClass("active");
    }
  });

  // FAQ Tabbing Code
  $(".faq-c-questionaire-o-block").fadeTo(0, 1);

  $(".btn-faq").click(function (event) {
    event.preventDefault();

    // Remove active class from all anchors and add to the clicked one
    $(".btn-faq").removeClass("btn-faq-active");
    $(this).addClass("btn-faq-active");

    const target = $(this).data("target");

    if (target === "faq-view-all-block") {
      // Show all FAQ blocks for the "View All" tab with fade effect
      $(".faq-c-questionaire-o-block").fadeTo("fast", 1);
    } else {
      // Hide all FAQ blocks and fade in the target one
      $(".faq-c-questionaire-o-block")
        .not("#" + target)
        .css("display", "none");
      $("#" + target).fadeTo("fast", 1);
    }
  });

  function moveFilterCats() {
    if ($(window).width() < 768) {
      $(".facets").appendTo(".ma-collection-filters");
    } else {
      // Optionally, move it back to the original position when the width is 768px or above
      $(".facets").appendTo(".facets-container");
    }
  }

  // Initial check
  moveFilterCats();

  // Check on window resize
  $(window).resize(function () {
    moveFilterCats();
  });
});

function updateSwiperNoSwiping() {
  const slides = document.querySelectorAll(".blog-carousel-slide");
  if (window.innerWidth < 1024) {
    slides.forEach((slide) => {
      slide.classList.remove("swiper-no-swiping");
    });
  } else {
    slides.forEach((slide) => {
      slide.classList.add("swiper-no-swiping");
    });
  }
}

// Run on initial load
updateSwiperNoSwiping();

// Run on window resize
window.addEventListener("resize", updateSwiperNoSwiping);

$(document).ready(function () {
  function removeClassOnResize() {
    if ($(window).width() < 768) {
      $(".our-products-catalogue-block-two").removeClass("jd-c-drag");
    } else {
      $(".our-products-catalogue-block-two").addClass("jd-c-drag"); // Optional: add it back if the screen size is above 768px
    }
  }

  // Initial check
  removeClassOnResize();

  // Add event listener for window resize
  $(window).resize(removeClassOnResize);
});

$(document).ready(function () {
  $("a.conctact-m-e-a-block").on("click", function (event) {
    var id = jQuery(this).attr("href");
    if (!id || id.trim() === "" || id.startsWith("#")) {
      event.preventDefault(); // Prevent the default anchor behavior
    } else {
      //default
    }
    $(".contact-miscellaneous-popup-block").removeClass("pactive");
    $(id).fadeIn(); // Fade in the popup
    $(id).addClass("pactive");
  });
  $(".c_close_popup").on("click", function () {
    $(".contact-miscellaneous-popup-block").hide();
  });

  /* For utility Pages Navbar */
  $(".up-cnt-nav-mainvb-block").on("click", function () {
    $(".utilitypage-navpopup-block").fadeIn("slow"); // Use 'fast', 'slow', or a time in milliseconds
  });

  $(".utilitypage-cnt-navxs-popuplinks-v-block a").on("click", function () {
    $(".utilitypage-navpopup-block").fadeOut("slow"); // Use 'fast', 'slow', or a time in milliseconds
    $(".utilitypage-cnt-navxs-popuplinks-v-block a").removeClass("active"); // Remove active class from all links within the same container
    $(this).addClass("active"); // Add active class to the clicked link
  });
});
// hide contact info popup if clicked outside
$(document).click(function (event) {
  var target = $(event.target);
  var popupBlock = $(".contact-miscellaneous-popup-block.pactive");
  var popupContainer = $(".contact-m-popup-cnt-block");

  if (target.is("a.conctact-m-e-a-block") || target.is(popupContainer)) {
    console.log("target");
    event.stopPropagation();
  } else if (
    target.is(popupBlock) &&
    !target.closest(popupBlock).length &&
    !target.is(popupContainer)
  ) {
    console.log("not target");
    popupBlock.hide();
  }
});

// function truncateByWords(selector, wordLimit) {
//   var element = document.querySelector(selector);
//   var words = element.textContent.split(' ');
//   if (words.length > wordLimit) {
//     element.textContent = words.slice(0, wordLimit).join(' ') + '...';
//   }
// }

// truncateByWords('.related-product-infohd-block h3', 5); // Limit to 10 words

/*
$(document).ready(function () {
  // Create a placeholder div for the original position
  var originalPosition = $('<div class="original-position"></div>');
  $('.mh-xs-tabs-wrapper').before(originalPosition);

  function moveTabs() {
    var windowWidth = $(window).width();
    var activeVehicleBox = $('.ma_vehicle_box.active');
    
    if (windowWidth < 768) {
      // Check if the active vehicle box is not the third or fourth
      if (!activeVehicleBox.is(':nth-of-type(3), :nth-of-type(4)')) {
        // Append after the second vehicle box only
        $('.ma_vehicle_box:nth-of-type(2)').after($('.mh-xs-tabs-wrapper'));
      } else {
        // Revert to original position when third or fourth is active
        $('.original-position').append($('.mh-xs-tabs-wrapper'));
      }
    } else {
      // Revert to original position on larger screens
      $('.original-position').append($('.mh-xs-tabs-wrapper'));
    }
  }

  // Initial check
  moveTabs();

  // Check on window resize
  $(window).resize(function () {
    moveTabs();
  });

  // Move when a vehicle box is clicked
  $('.ma_vehicle_box').click(function () {
    $('.ma_vehicle_box').removeClass('active');
    $(this).addClass('active');
    moveTabs();
  });
});
*/
